import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles, ServerStyleSheets } from '@material-ui/core/styles';

import { useAppContext } from '../context/app.state';

const useStyles = makeStyles(() => ({
  title: {
    flexGrow: 1,
  },
}));

const AppBarTitle = () => {
  const classes = useStyles();
  const appContext = useAppContext();
  const { state } = appContext;
  const { appBarTitle } = state;
  return (
    <Typography
      suppressHydrationWarning
      variant="h6"
      noWrap
      className={classes.title}
    >
      {appBarTitle}
    </Typography>
  );
};

AppBarTitle.defaultProps = {};
AppBarTitle.propTypes = {};
export default AppBarTitle;
